import { DefaultTransitionState } from './DefaultTransitionState';
import type { InteractionVisualStateRuntime } from './AbstractInteractionVisualState';
import type { Viewer } from '../../viewer/Viewer';

/**
 * 基准轴模式视觉状态。
 *
 * 说明：
 * 1. 当前阶段沿用默认模式的高亮语义；
 * 2. 该独立状态类用于承接后续基准轴专属视觉差异扩展；
 * 3. 通过单独文件隔离职责，避免继续把模式分支堆回管理器。
 */
export class ReferenceAxisTransitionState extends DefaultTransitionState {
    /**
     * @param runtime 视觉状态运行时。
     * @param viewer Viewer 实例。
     */
    public constructor(runtime: InteractionVisualStateRuntime, viewer: Viewer) {
        super(runtime, viewer);
    }
}
